<script>

  import { setCircleStyling, showSettingsPopup } from '../service/LmsUIService';
  import ColorPicker from '../../Common/ColorPicker.svelte';
  import TextStyling from './TextStyling.svelte';
  import Slider from '../../Common/Slider.svelte';
  import { External, M } from '../../external';
  import Checkbox from '../../Common/Checkbox.svelte';
  import CircleImageStyling from './CircleImageStyling.svelte';
  import IconStyling from './IconStyling.svelte';
  import SidebarStyling from './SidebarStyling.svelte';

  export let circle, onChange = () => {
  };

  let circleStyling = setCircleStyling(circle);

  let selectShadow = () => {
    External.UITools.selectShadow(circleStyling.shadow, External.jQuery(document.querySelector('#circle-wrapper')), function(shadow) {
      circleStyling.shadow = shadow;
      onChange();
    }, true);
  };

  let notifyChanged = () => {
    onChange();
  };

  let showCircleTextStyling = () => {
    showSettingsPopup({
      component: (target) =>
        new TextStyling({
          target: target,
          props: {
            styling: circleStyling.textStyling,
            onChange: notifyChanged
          }
        })
    });
  };

  let showIconsStyling = () => {
    showSettingsPopup({
      component: (target) =>
        new IconStyling({
          target: target,
          props: {
            styling: circleStyling.iconStyling,
            onChange: notifyChanged
          }
        })
    });
  };

  let editImage = () => {
    showSettingsPopup({
      component: (target) =>
        new CircleImageStyling({
          target: target,
          props: {
            styling: circleStyling.thumbnail,
            onChange: notifyChanged
          }
        })
    });
  };

  let showSidebarStyling = () => {
    showSettingsPopup({
      component: (target) =>
        new SidebarStyling({
          target: target,
          props: {
            styling: circleStyling.sidebar,
            onChange: notifyChanged
          }
        })
    });
  };
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> brush </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.CIRCLE_STYLING}</h4>
  <div class="popup-input-wrapper f-left mb-5">
    <div class="info">
      <h5>{M.SIDEBAR_STYLE}</h5>
    </div>
    <select class="page-select" bind:value={circleStyling.menuSize} on:change={notifyChanged}>
      <option value="compact">{M.COMPACT}</option>
      <option value="wide">{M.WIDE}</option>
    </select>
  </div>
  <div class="col20 f-left">
    <Checkbox bind:data={circleStyling.hasExpandButton} onChange={notifyChanged} label={M.ADD_EXPAND_COLLAPSE}
              description={M.ADD_EXPAND_COLLAPSE_DESC} />
  </div>
  <div class="col20 f-left">
    <Checkbox bind:data={circleStyling.hasProfileButton} onChange={notifyChanged} label={M.ADD_PROFILE_BUTTON}
              description={M.ADD_PROFILE_BUTTON_DESC} />
  </div>
  <div class="col20 f-left">
    <Checkbox bind:data={circleStyling.showCirclePadding} onChange={notifyChanged} label={M.ADD_CIRCLE_PADDING}
              description={M.ADD_CIRCLE_PADDING_DESC} />
  </div>
  {#if circleStyling.showCirclePadding}
    <div class="input-wrapper">
      <Slider bind:value={circleStyling.circlePadding} min={5} max={100} label={M.PADDING_SIZE} onChange={notifyChanged} />
    </div>
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker
        bind:color={circleStyling.bg.color}
        bind:colorClass={circleStyling.bg.colorClass}
        onChange={notifyChanged}
        label={M.CIRCLE_BACKGROUND_COLOR}
      />
    </div>
  {/if}
  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={circleStyling.navBg.color}
      bind:colorClass={circleStyling.navBg.colorClass}
      onChange={notifyChanged}
      label={M.SIDEBAR_BACKGROUND_COLOR}
    />
  </div>
  <div class="input-wrapper">
    <Slider bind:value={circleStyling.navigationWidth} min={100} max={500}
            label={M.NAVIGATION_WIDTH} onChange={notifyChanged} />
  </div>
  <div class="col20 f-left">
    <Checkbox bind:data={circleStyling.fixToViewportHeight} onChange={notifyChanged}
              label={M.HEIGHT_VIEWPORT}
              description={M.HEIGHT_VIEWPORT_DESC} />
  </div>

  {#if circleStyling.fixToViewportHeight}
    <div class="input-wrapper">
      <Slider bind:value={circleStyling.viewportHeight} min={50} max={100}
              label={M.FIXED_HEIGHT} suffix="%" onChange={notifyChanged} />
    </div>
  {/if}
  <div class="col20 f-left">
    <Checkbox bind:data={circleStyling.darkTheme} onChange={notifyChanged} label={M.USE_DARK_THEME}
              description={M.DARK_THEME_DESC} />
  </div>

  <div class="col20 f-left">
    <Checkbox bind:data={circleStyling.roundCorners} onChange={notifyChanged} label={M.ROUND_CORNERS} />
  </div>

  <div class="col20 f-left">
    <Checkbox bind:data={circleStyling.addShadow} onChange={notifyChanged} label={M.ADD_SHADOW}
              description={M.ADD_SHADOW_CIRCLE} />
  </div>
  {#if circleStyling.addShadow}
    <div class="col20 mb-5 f-left gray-section product-select-wrapper">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.SHADOW}</h4>
        <a on:click={selectShadow} class="text-link blue-text">{M.CHANGE}</a>
      </div>
    </div>
  {/if}

  <div class="col20 mb-5 f-left gray-section product-select-wrapper">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">{M.CIRCLE_IMAGE}</h4>
      <a on:click={editImage} class="text-link blue-text">{M.STYLE}</a>
    </div>
  </div>
  <div class="col20 mb-5 f-left gray-section product-select-wrapper">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">{M.CIRCLE_TEXT_STYLING}</h4>
      <a on:click={showCircleTextStyling} class="text-link blue-text">{M.CHANGE}</a>
    </div>
  </div>
  <div class="col20 mb-15 f-left gray-section product-select-wrapper">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">{M.ICONS_STYLING}</h4>
      <a on:click={showIconsStyling} class="text-link blue-text">{M.CHANGE}</a>
    </div>
  </div>
  <div class="popup-input-wrapper f-left mt-0">
    <div class="info">
      <h5>{M.WHERE_TO_SHOW_GROUP_SUBMENU}</h5>
    </div>
    <select class="page-select" bind:value={circleStyling.submenuStyle} on:change={notifyChanged}>
      <option value="inline">{M.INLINE_SUBMENU}</option>
      <option value="replace">{M.SLIDE_SUBMENU}</option>
      <option value="sidebar">{M.OWN_SIDEBAR}</option>
    </select>
  </div>

  {#if circleStyling.submenuStyle === 'sidebar'}
    <div class="col20 mb-15 f-left gray-section product-select-wrapper">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.SIDEBAR_STYLING}</h4>
        <a on:click={showSidebarStyling} class="text-link blue-text">{M.CHANGE}</a>
      </div>
    </div>
  {/if}
</div>

